import Dog from './dog.js';


export default class Game {
  // constructor(ctx, dog) {
  //   this.ctx = ctx;
  //   this.dog = new Dog;
  // }
  //
  // drawBorder () {
  //   this.ctx.rect(20,20,700,700);
  //   this.ctx.stroke();
  // }
}



// WEBPACK FOOTER //
// ./lib/game.js